import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import React, { memo, useContext, useRef } from 'react';
import { ModalContext } from './ModalContext.js';
import useOutsideClick from '../../hooks/useOutsideClick.js';

var _excluded = ["children"];
var _templateObject;
var lfgModalSizeMap = {
  large: '42.5rem',
  medium: '42.5rem',
  small: '22.1875rem'
};
var StyledContainer = styled('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: #fff;\n  border-radius: 0px;\n  box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);\n  max-height: ", ";\n  max-width: ", ";\n  overflow: auto;\n  transform: scale(", ");\n  transition: transform 0.3s;\n  background-color: #fff;\n  max-width: ", ";\n  padding: 0rem 2.1875rem;\n"])), function (_ref) {
  var _ref$maxHeight = _ref.maxHeight,
    maxHeight = _ref$maxHeight === void 0 ? '100%' : _ref$maxHeight;
  return maxHeight;
}, function (_ref2) {
  var _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 'medium' : _ref2$size;
  return lfgModalSizeMap[size];
}, function (_ref3) {
  var isOpen = _ref3.isOpen;
  return !isOpen ? '0' : '1';
}, function (_ref4) {
  var _ref4$size = _ref4.size,
    size = _ref4$size === void 0 ? 'large' : _ref4$size;
  return lfgModalSizeMap[size];
});
var handleOutsideClick = function handleOutsideClick(setIsOpen, disabledBackdropClick) {
  return function () {
    if (!disabledBackdropClick) {
      setIsOpen(false);
    }
  };
};
var ModalContainer = function ModalContainer(_ref5) {
  var children = _ref5.children,
    rest = _objectWithoutProperties(_ref5, _excluded);
  var _useContext = useContext(ModalContext),
    disabledBackdropClick = _useContext.disabledBackdropClick,
    isOpen = _useContext.isOpen,
    setIsOpen = _useContext.setIsOpen,
    size = _useContext.size,
    containerMaxHeight = _useContext.containerMaxHeight;
  var containerRef = useRef(null);
  useOutsideClick([containerRef], handleOutsideClick(setIsOpen, disabledBackdropClick));
  return /*#__PURE__*/React.createElement(StyledContainer, _extends({
    isOpen: isOpen,
    ref: containerRef,
    size: size,
    maxHeight: containerMaxHeight
  }, rest), children);
};
var ModalContainer$1 = /*#__PURE__*/memo(ModalContainer);

export default ModalContainer$1;
export { ModalContainer };
